import "./administration.css";

import React, { Component } from "react";
import { TabContent, TabPane } from "reactstrap";

import Companies from "./companies";
import Crops from "./crops";
import { LevelHeader } from "../clientDashboard/components/LevelHeader";
import UploadTemplates from "./uploadTemplates";
import { connect } from "react-redux";

const TABS = [
  { id: "Companies", label: "Companies", icon: "fa-building" },
  { id: "Templates", label: "Upload Templates", icon: "fa-file-lines" },
  { id: "Crops", label: "Crops", icon: "fa-seedling" },
];

class Administration extends Component {
  state = {
    activeTab: "Companies",
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
  }

  render() {
    return (
      <div className="page-content container-fluid cf-page admin-tabbed">
        <LevelHeader path={[{ label: "Administration" }]} />

        <div className="admin-tabs" role="tablist" aria-label="Administration">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={this.state.activeTab === tab.id}
              className={
                "admin-tabs__btn" +
                (this.state.activeTab === tab.id ? " is-active" : "")
              }
              onClick={() => this.toggle(tab.id)}
            >
              <i className={"fa-solid " + tab.icon} aria-hidden="true" />
              {tab.label}
            </button>
          ))}
        </div>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="Companies">
            <Companies history={this.props.history} />
          </TabPane>
          <TabPane tabId="Templates">
            <UploadTemplates />
          </TabPane>
          <TabPane tabId="Crops">
            <Crops />
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

const callbacks = {};

export default connect(mapStateToProps, callbacks)(Administration);
